const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');

const SIDE_MENU_VALUES = [
  {text:'left arm',  value:'left'},
  {text:'right arm', value:'right'},
];

//B011 (Wave)
const B011_VALUES = [
{text:'left small',          value:'sh_simple_wave_left'},
{text:'right small',         value:'sh_simple_wave_right'},
{text:'left medium',         value:'sh_circle_wave_left'},
{text:'right medium',        value:'sh_circle_wave_right'},
{text:'left large',          value:'sh_vertical_wiggle_left'},
{text:'right large',         value:'sh_vertical_wiggle_right'},
];

//B018 (Bow)
const B018_VALUES = [
{text:'bow intro left',      value:'kf_bow_intro_left'},
{text:'bow intro right',     value:'kf_bow_intro_right'},
];
//B019 (Chop)
const B019_VALUES = [
{text:'left chop behind',    value:'kf_chop_dormant_left'},
{text:'right chop behind',   value:'kf_chop_dormant_right'},
{text:'left chop mid',       value:'kf_chop_mid_left'},
{text:'right chop mid',      value:'kf_chop_mid_right'},
{text:'left chop high',      value:'kf_chop_high_left'},
{text:'right chop high',     value:'kf_chop_high_right'},
{text:'left chop low',       value:'kf_chop_low_left'},
{text:'right chop low',      value:'kf_chop_low_right'},
{text:'left crane pose',     value:'kf_crane_pose_left'},
{text:'right crane pose',    value:'kf_crane_pose_right'},
{text:'left wax on',         value:'kf_wax_on_left'},
{text:'right wax on',        value:'kf_wax_on_right'},
];
//B020 (Block)
const B020_VALUES = [
{text:'left',           value:'kf_block_high_left'},
{text:'right',          value:'kf_block_high_right'},
];
//B021 (Idle Circle)
const B021_VALUES = [
{text:'left low',            value:'kf_idle_low_left'},
{text:'right low',           value:'kf_idle_low_right'},
{text:'left high',           value:'kf_idle_high_left'},
{text:'right high',          value:'kf_idle_high_right'},
];
//B024 (Arm Wiggle)
const B024_VALUES = [
{text:'left stretch',        value:'wide_stretch_left'},
{text:'right stretch',       value:'wide_stretch_right'},
{text:'left waft',           value:'smelly_hand_wave_left'},
{text:'right waft',          value:'smelly_hand_wave_right'},
{text:'left shock',          value:'shock_left'},
{text:'right shock',         value:'shock_right'},
{text:'left crazy',          value:'sh_crazy_arm_left'},
{text:'right crazy',         value:'sh_crazy_arm_right'},
];

//B026 (Dance Hand)
const B026_VALUES = [
{text:'left swing',          value:'u_shape_left'},
{text:'right swing',         value:'u_shape_right'},
{text:'left glide',          value:'slow_c_left'},
{text:'right glide',         value:'slow_c_right'},
{text:'left wiggle',         value:'bow_left'},
{text:'right wiggle',        value:'bow_right'},
{text:'left robot up/down',  value:'zigzag_left'},
{text:'right robot up/down', value:'zigzag_right'},
{text:'left circle',         value:'circle_wave_left'},
{text:'right circle',        value:'circle_wave_right'},
{text:'left around',         value:'forward_back_left'},
{text:'right around',        value:'forward_back_right'},
];

//B030 (Fart/burp Hands)
const B030_VALUES = [
{text:'left low',            value:'fart_arms_low_left'},
{text:'right low',           value:'fart_arms_low_right'},
{text:'left medium',         value:'fart_arms_mid_left'},
{text:'right medium',        value:'fart_arms_mid_right'},
{text:'left large',          value:'fart_arms_high_left'},
{text:'right large',         value:'fart_arms_high_right'},
];


const LOOP_VALUES = ['1','2','3','4','5'];

const HANDS_AND_ARMS_BLOCKS = [
  { opcode:'say_hey_wave', text:'wave [TYPE] [LOOPS]', args:{TYPE:{menu:'B011_menu', type:'string'},LOOPS:{menu:'Loop_menu', type:'string'}}, anim:{name:'{TYPE}', loops:'{LOOPS}'} }, //B011
  { opcode:'arm_burp', text:'burp hands [TYPE]', args:{TYPE:{menu:'B030_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B030
  { opcode:'arm_fart', text:'fart hands [TYPE]', args:{TYPE:{menu:'B030_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B030
  { opcode:'arm_wiggle', text:'gesture arm [TYPE]', args:{TYPE:{menu:'B024_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B024
  { opcode:'arm_bow', text:'kungfu bow arm [TYPE]', args:{TYPE:{menu:'B018_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B018
  { opcode:'arm_chop', text:'kungfu chop arm [TYPE]', args:{TYPE:{menu:'B019_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B019
  { opcode:'arm_block', text:'kungfu block arm [TYPE]', args:{TYPE:{menu:'B020_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B020
  { opcode:'arm_idle', text:'kungfu circle arm [TYPE]', args:{TYPE:{menu:'B021_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B021
  { opcode:'dance_hand', text:'dance arm [TYPE]', args:{TYPE:{menu:'B026_menu', type:'string'}}, anim:{name:'{TYPE}', loops:1} }, //B026
];


function argSpec(argKey, spec) {
  if (typeof spec === 'string') return { type: ArgumentType.STRING, menu: spec };
  const t = spec?.type === 'number' ? ArgumentType.NUMBER : ArgumentType.STRING;
  return spec?.menu ? { type: t, menu: spec.menu } : { type: t };
}

function interpolate(tpl, args) {
  return String(tpl).replace(/\{(\w+)\}/g, (_, k) => String(args[k] ?? '').replace(/\s+/g,'_'));
}

function toNumberMaybe(v) {
  const n = Number(v); return Number.isFinite(n) ? n : undefined;
}

const buildBlocks = (rawBlocks) => rawBlocks.map(b => ({
    opcode: b.opcode,
    blockType: BlockType.COMMAND,
    text: b.text,
    arguments: Object.fromEntries(Object.entries(b.args || {}).map(([k, spec]) => ([k, argSpec(k, spec)])))
}));

function getBlockHandler(b) {
    return function(args) { // Use 'function' to bind 'this' correctly
        const op = b.anim.op || 'play_animation';
        if (op === 'play_animation') {
            const name = interpolate(b.anim.name, args);
            const variant = b.anim.variant ? interpolate(b.anim.variant, args) : 'default';
            const loops = typeof b.anim.loops === 'string' ? toNumberMaybe(args[b.anim.loops.replace(/[{}]/g, '')]) ?? 1 : (b.anim.loops ?? 1);
            const payload = `{"animName":"${name}","state":"true","variantKey":"${variant}","loops":${loops}}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        } else {
            const payload = `{}`;
            return this.sendWaitAck({ OP: op, PAYLOAD: payload, TIMEOUT: -1 });
        }
    };
}

class Scratch3CodematesHands {
    constructor(runtime) {
        this.runtime = runtime;
        this._pending = new Map();
        this._events = new Map();
        this._awaiters = new Map();
        this._onUnityMessage = this._onUnityMessage.bind(this);
        window.addEventListener('unity-message', this._onUnityMessage);
        this.installHandlers(HANDS_AND_ARMS_BLOCKS);
    }

    initWebGL() { this.sendNow({ OP:'unity_init' }); }
    resetWebGL() { this.sendNow({ OP:'unity_cleanUp' }); }
    
    getInfo() {
        return {
            id: 'codematesHands',
            name: '👋 Patch\'s Hands',
            color1: '#8a0669',
            blocks: buildBlocks(HANDS_AND_ARMS_BLOCKS),
            menus: {
                B011_menu: { acceptReporters: false, items: B011_VALUES },
                B018_menu: { acceptReporters: false, items: B018_VALUES },
                B019_menu: { acceptReporters: false, items: B019_VALUES },
                B020_menu: { acceptReporters: false, items: B020_VALUES },
                B021_menu: { acceptReporters: false, items: B021_VALUES },
                B024_menu: { acceptReporters: false, items: B024_VALUES },
                B026_menu: { acceptReporters: false, items: B026_VALUES },
                B030_menu: { acceptReporters: false, items: B030_VALUES },
                Loop_menu: { acceptReporters: false, items: LOOP_VALUES },
                sideMenu: { acceptReporters: false, items: SIDE_MENU_VALUES },
            }
        };
    }
    
    installHandlers(blocks) {
        for (const b of blocks) { this[b.opcode] = getBlockHandler(b).bind(this); }
    }

    // RPC Logic
    sendNow(args) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD || '{}'));
        this._post({ seq: ++this._seq, op, data: payload });
    }

    sendWaitAck(args) {
        const op = Cast.toString(args.OP);
        const payload = this._parse(Cast.toString(args.PAYLOAD));
        const n = Number(args.TIMEOUT);
        const timeout = Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
        return this._rpc(op, payload, { waitFor: 'ack', timeout });
    }

    _rpc(op, payload = {}, { timeout = 2000, waitFor } = {}) {
        window.__codemates_seq = window.__codemates_seq || 0;
        const seq = ++window.__codemates_seq;
        const body = { seq, op, data: payload };
        const p = new Promise((resolve, reject) => {
            let t = null;
            if (timeout) {
                t = setTimeout(() => { this._pending.delete(seq); resolve({ seq, op, timeout: true }); }, timeout);
            }
            this._pending.set(seq, { resolve, reject, t, waitFor });
        });
        this._post(body);
        return p;
    }

    _post(body) {
        if (typeof window.sendToUnity === 'function') { try { window.sendToUnity(body); } catch {} }
        else { (window.__unityQueue = window.__unityQueue || []).push(body); }
    }

    _parse(s) {
        try { const o = JSON.parse(s); return typeof o === 'object' && o !== null ? o : { value: s }; }
        catch { return { value: s }; }
    }

    _queueEvent(name, data) {
        const q = this._events.get(name) || [];
        q.push(data);
        this._events.set(name, q);
        const aw = this._awaiters.get(name);
        if (aw && aw.length) aw.shift()();
        this.runtime.startHats('codemates_whenUnityEvent', { EVENT: name });
    }

    _popEvent(name) {
        const q = this._events.get(name) || [];
        if (!q.length) return false;
        q.shift();
        return true;
    }

    _waitForEvent(name) {
        if (this._popEvent(name)) return Promise.resolve();
        return new Promise(r => {
            const list = this._awaiters.get(name) || [];
            list.push(r);
            this._awaiters.set(name, list);
        });
    }

    _onUnityMessage(evt) {
        const msg = evt && (evt.detail || evt.data);
        if (!msg || typeof msg !== 'object') return;
        if (msg.type === 'event' && msg.name) { this._queueEvent(msg.name, msg); return; }
        if (msg.seq && this._pending.has(msg.seq)) {
            const entry = this._pending.get(msg.seq);
            if (entry.t) clearTimeout(entry.t);
            if (!entry.waitFor || entry.waitFor === msg.type || msg.type === 'error') {
                this._pending.delete(msg.seq);
                if (msg.type === 'error') entry.reject(new Error(msg.error || 'unity error'));
                else entry.resolve(msg);
            }
        }
    }
}


// --- EXPORT THE SINGLE EXTENSION CLASS ---
module.exports = Scratch3CodematesHands;
